import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/use-auth';
import { pasosDeGestion } from '../components/encabezado-de-gestion';

/**
 * `/cotiza/gestion` (el menú y la miga «Gestión»): lleva a las cotizaciones, el
 * paso que más se usa, o al primero que la persona pueda abrir.
 */
export function GestionInicio() {
  const { canSeeMenu, isModuleLocked, menuItems } = useAuth();
  const pasos = pasosDeGestion((k) => canSeeMenu(k) && !isModuleLocked(k), menuItems).filter(
    (p) => p.visible
  );
  const destino = pasos.find((p) => p.id === 'cotizaciones') ?? pasos[0];
  return <Navigate to={destino?.href ?? '/cotiza/vision-general'} replace />;
}

export default GestionInicio;
